if ( typeof AnnouncementBar !== 'function' ) {

  class AnnouncementBar extends HTMLElement {

    constructor() {

      super();

      this.slider = this.querySelector('[data-js-slider]');
      this.content = Array.from(this.querySelectorAll('.announcement')).filter((item)=>{
        const hasText = item.textContent.trim().length > 0;
        if ( ! hasText ) {
          item.remove();
        }
        return hasText;
      });
      this.content.forEach((item)=> {
        item.style.display = '';
        this.slider?.appendChild(item);
      });
      this.nextButton = this.querySelector('.announcement-bar__content-nav--right');
      this.prevButton = this.querySelector('.announcement-bar__content-nav--left');

      this.index = 0;
      this.length = this.content.length;
      this.autoplayInterval = parseInt(this.dataset.autoplayInterval || '0', 10);
      this.goToSlide(0);
      window.addEventListener('resize', ()=>{
        this.goToSlide(this.index);
      });
      
      if ( this.nextButton ) {
        this.nextButton.addEventListener('click', ()=>{
          this.changeSlide('next');
          this.restartAutoplay();
        });
      }
      if ( this.prevButton ) {
        this.prevButton.addEventListener('click', ()=>{
          this.changeSlide('prev');
          this.restartAutoplay();
        });
      }

      if ( this.length > 1 && this.autoplayInterval > 0 ) {
        this.startAutoplay();
      }
      
    }

    changeSlide(direction) {

      if ( ! this.slider || this.length <= 0 ) return;

      let nextIndex = this.index;
      let tries = 0;

      do {
        if ( direction == 'next' ) {
          nextIndex = nextIndex === this.length - 1 ? 0 : nextIndex + 1;
        } else if ( direction == 'prev' ) {
          nextIndex = nextIndex === 0 ? this.length - 1 : nextIndex - 1;
        }
        tries++;
      } while ( tries < this.length && ! this.content[nextIndex]?.textContent.trim() );

      this.goToSlide(nextIndex);

    }

    goToSlide(index) {
      if ( ! this.slider || this.length <= 0 ) return;
      this.index = Math.max(0, Math.min(index, this.length - 1));
      const currentSlide = this.content[this.index];
      const slideHeight = currentSlide?.offsetHeight || this.querySelector('.announcement-bar__content')?.offsetHeight || 0;
      const slideTop = currentSlide?.offsetTop || 0;
      this.slider.style.height = `${slideHeight}px`;
      this.slider.style.transform = `translateY(-${slideTop}px)`;
    }

    startAutoplay() {
      this.autoplayTimer = setInterval(()=>{
        this.changeSlide('next');
      }, this.autoplayInterval);
    }

    restartAutoplay() {
      if ( ! this.autoplayTimer || ! this.autoplayInterval ) return;
      clearInterval(this.autoplayTimer);
      this.startAutoplay();
    }

  }

  if ( typeof customElements.get('announcement-bar') == 'undefined' ) {
    customElements.define('announcement-bar', AnnouncementBar);
	}

}
